import { Button, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { login as loginAction } from '@redux/auth/actions';

const FormItem = Form.Item;

const Login = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const loading = useSelector((state) => state.auth.loading);
  const login = (params) => dispatch(loginAction(params));
  const handleSubmit = () => {
    // e.preventDefault();
    form
      .validateFields()
      .then((values) => {
        login(values);
      })
      .catch(() => {
        // console.log('err', err);
      });
  };
  if (isAuthenticated) {
    return <Redirect to="/" />;
  }
  return (
    <>
      <h3 className="fw-700 size-xl text-dark-highlight">
        Bạn đã sẵn sàng để kết nối Talentmate.vn?
      </h3>
      <a href="/register">
        <div className="fw-700 text-gray size-l">
          Tạo tài khoản hoặc đăng nhập.
        </div>
      </a>
      <div className="text-gray mt-24">
        Bằng cách tạo tài khoản hoặc đăng nhập, bạn hiểu và đồng ý với{' '}
        <a className="text-highlight">Điều khoản</a>. Bạn cũng xác nhận chính
        sách <a>Cookie</a> và <a className="text-highlight">Quyền riêng tư</a>{' '}
        của{' '}
        <a className="text-highlight">
          <b>Talentmate</b>
        </a>
        .
      </div>
      <br />
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <FormItem
          name="email"
          rules={[
            {
              required: true,
              message: t('input.email.validateMsg.required'),
            },
            {
              type: 'email',
              message: t('input.email.validateMsg.invalid'),
            },
          ]}
          label="Email"
        >
          <Input
            placeholder={t('input.email.placeholder')}
            autoComplete="off"
            style={{ height: '40px' }}
          />
        </FormItem>
        <FormItem
          name="password"
          rules={[
            {
              required: true,
              message: t('input.password.validateMsg.required'),
            },
          ]}
          label="Password"
        >
          <Input.Password
            style={{ height: '40px' }}
            placeholder={t('input.password.placeholder')}
            autoComplete="off"
            type="password"
          />
        </FormItem>
        <div
          style={{
            marginBottom: 20,
            fontSize: '14px',
            textAlign: 'right',
            fontWeight: '600',
          }}
        >
          {/* <Link to="/forgot-password" href="/forgot-password">
            {t('forgotPassword.title')}
          </Link> */}
        </div>
        <div className="action-div">
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="login-form-button"
            style={{ height: '42px' }}
          >
            {t('login.loginBtn')}
          </Button>
        </div>
      </Form>
    </>
  );
};

Login.propTypes = {};

export default Login;
